import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  .mobile {
    display: none;
  }

  ${media.mobile`
    .desk {
      display: none;
    }
    .mobile {
      display: block;
      width: 326px;
      margin: 0 auto;
    }
  `}
  ${media.se`
    .mobile {
      width: 300px;
    }
  `}
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Td = styled.td`
  width: 164px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  letter-spacing: 0.4px;
  color: #343434;
  border: 1px solid #e9e9e9;
  text-align: center;

  &.m {
    font-size: 14px;
  }
  &.kids {
    width: 412px;
  }
  &.head {
    width: 202px;
  }
`;

const Th = Td.extend`
  width: 164px;
  text-align: left;
  font-weight: 700;
  padding-left: 26px;
  color: #747474;
  background: #f9f9f9;

  &.m {
    font-size: 14px;
    text-align: center;
    padding-left: 0;
  }
`;

export const BabyTable = () => (
  <Wrapper>
    <Table className="desk">
      <tbody>
        <tr>
          <Th className="head">AGE</Th>
          <Td>3-6mos</Td>
          <Td>6-12mos</Td>
          <Td>12-18mos</Td>
          <Td>18-24mos</Td>
          <Td>2T</Td>
        </tr>
        <tr>
          <Th className="head">HEIGHT</Th>
          <Td>59-68cm</Td>
          <Td>68-73cm</Td>
          <Td>73-79cm</Td>
          <Td>79-84cm</Td>
          <Td>84-91cm</Td>
        </tr>
      </tbody>
    </Table>
    <Table className="mobile">
        <tbody>
          <tr>
            <Th className="m">AGE</Th>
            <Th className="m">HEIGHT</Th>
          </tr>
          <tr>
            <Td className="m">3-6mos</Td>
            <Td className="m">56-68cm</Td>
          </tr>
          <tr>
            <Td className="m">6-12mos</Td>
            <Td className="m">68-73cm</Td>
          </tr>
          <tr>
            <Td className="m">12-18mos</Td>
            <Td className="m">73-79cm</Td>
          </tr>
          <tr>
            <Td className="m">18-24mos</Td>
            <Td className="m">79-84cm</Td>
          </tr>
          <tr>
            <Td className="m">2T</Td>
            <Td className="m">84-91cm</Td>
          </tr>
        </tbody>
      </Table>
  </Wrapper>
);

export const KidsTable = () => (
    <Wrapper>
      <Table className="desk">
        <tbody>
          <tr>
            <Th className="head">AGE</Th>
            <Td className="kids">18-2T</Td>
            <Td className="kids">2-4T</Td>
          </tr>
          <tr>
            <Th className="head">HEIGHT</Th>
            <Td className="kids">78-92cm</Td>
            <Td className="kids">86-106cm</Td>
          </tr>
        </tbody>
      </Table>

      <Table className="mobile">
        <tbody>
          <tr>
            <Th className="m">AGE</Th>
            <Th className="m">HEIGHT</Th>
          </tr>
          <tr>
            <Td className="m">18-2T</Td>
            <Td className="m">78-92cm</Td>
          </tr>
          <tr>
            <Td className="m">2-4T</Td>
            <Td className="m">86-106cm</Td>
          </tr>
        </tbody>
      </Table>
    </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/About/SizeTable.js